<script setup>
import { inject } from "vue";

const bulk_upload_response = inject("bulk_upload_response");
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">UPDATED DEVICES</h3>
            </div>
            <div class="card-body" x-data="filter-options">
              <div class="row">
                <label
                  v-if="bulk_upload_response.duplicateData?.length !== 0"
                  style="color: red"
                >
                  {{ bulk_upload_response.duplicateData?.length }}
                  device{{
                    bulk_upload_response.duplicateData?.length === 1 ? "" : "s"
                  }}
                  already exist.
                </label>
                <table
                  v-if="bulk_upload_response.duplicateData?.length !== 0"
                  class="table table-striped"
                >
                  <thead>
                    <tr>
                      <th>ROW NO.</th>
                      <th>IMEI</th>
                      <th>ICCID</th>
                      <th>MSISDN</th>
                      <th>Device Class</th>
                      <th>Device Type</th>
                      <th>Provider</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="duplicate in bulk_upload_response.duplicateData"
                      :key="duplicate.row"
                    >
                      <td>{{ duplicate.row }}</td>
                      <td>{{ duplicate.imei }}</td>
                      <td>{{ duplicate.iccid }}</td>
                      <td>{{ duplicate.msisdn }}</td>
                      <td>{{ duplicate.device_class }}</td>
                      <td>{{ duplicate.device_type }}</td>
                      <td>{{ duplicate.provider }}</td>
                    </tr>
                  </tbody>
                </table>

                <div v-else style="color: green; font-weight: bold">
                  No Updated Devices
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style></style>
